var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBurgerMenu = function SvgBurgerMenu(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 4.3c0-.44.35-.8.79-.8H22.2a.8.8 0 0 1 .79.8.8.8 0 0 1-.79.8H1.8a.8.8 0 0 1-.8-.8m0 7.95c0-.44.35-.8.79-.8H22.2a.8.8 0 0 1 .79.8.8.8 0 0 1-.79.8H1.8a.8.8 0 0 1-.79-.8Zm.79 7.16a.8.8 0 0 0-.79.8c0 .43.35.79.79.79H22.2a.8.8 0 0 0 .79-.8.8.8 0 0 0-.79-.8H1.8Z",
    clipRule: "evenodd"
  })));
};
export { SvgBurgerMenu as ReactComponent };
export default __webpack_public_path__ + "static/media/burgerMenu.8851cd4f0913a0e85eb54dd522551cab.svg";